import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getFaqService } from 'selfServicePortal/services/CustomerServices/getFaqService'

export const useFaq = (productType: string) => {
	const { i18n } = useTranslation()
	return useQuery(
		['faq', productType, i18n.language],
		() => getFaqService(productType, i18n.language),
		{
			staleTime: Infinity,
			cacheTime: Infinity,
			refetchOnWindowFocus: false,
			retry: false,
		},
	)
}
